import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Buffer } from 'buffer'
import { env } from '@/config/env.ts'
import '@/i18n/index.ts'
import '@/styles/index.css'
import '@/services/wallet/reown.config.ts'
import { AppProviders } from '@/app/providers/index.ts'
import { App } from '@/app/App.tsx'

if (env.enableDebug) {
  void import('@/config/debug.init.ts').then((m) => m.initDebugMode())
}

if (import.meta.env.DEV) {
  console.info(
    '[BitsLegacy dev] Open http://localhost:3000 — this project uses port 3000 (not the default Vite port 5173). If the home page looks stale: in DevTools → Network, enable "Disable cache", hard-reload; or run rm -rf node_modules/.vite && npm run dev after stopping other vite processes on port 3000.',
  )
}

// WalletConnect SDK expects Buffer to exist in browser.
if (typeof globalThis !== 'undefined' && !(globalThis as any).Buffer) {
  ;(globalThis as any).Buffer = Buffer
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
)
